import React from 'react'
import styled from 'styled-components'
import {darken} from 'polished'
import {Button, Icon, Popup} from '@startlibs/components'
import {usePopupToggle} from '@startlibs/core'
import {getColor, oneWayAnimation} from '@startlibs/utils'

const fadeInUp = oneWayAnimation('transform: translateY(10px); pointer-events: none; opacity: 0;', 'transform: translateY(0); pointer-events: none; opacity: 1;')

export const HelpButton = styled(({className}) => {
    const helpBubble = usePopupToggle()

    return <div className={className} onClick={helpBubble.open}>
        <Icon icon="help"/>
        {
            helpBubble.isOpen &&
            <HelpBubble/>
        }
    </div>
})`
  position: fixed;
  z-index: 10;
  bottom: 2rem;
  right: 2rem;
  width: 56px;
  text-align: center;
  border-radius: 5rem;
  background: ${getColor('main')};
  cursor: pointer;
  :hover {
    background: ${props => darken(0.035, getColor('main')(props))};
  }
  :active {
    background: ${props => darken(0.06, getColor('main')(props))};
  }
  ${Icon} {
    font-size: 40px;
    color: white;
    line-height: 56px;
  }
`
export const HelpBubble = styled(({className}) => <Popup arrow="-28" offset="0 15" className={className}
                                                         animation={fadeInUp}>
    <h4>Need help?</h4>
    <p>Contact <a className="link" href="mailto:support@purview.net" target="_blank">support@purview.net</a> or <span
        className="nowrap">call <b>+1 800-501-1537</b>.</span></p>
      <Button.a href="https://info.purview.net/hubfs/SECURE%20SHARE%20Purview%20Viewer%20with%203D%20Tools.pdf" highlight target="_blank">Get the viewer guide</Button.a>
</Popup>)`
  z-index: 10;
  padding: 1.5rem;
  border-radius: 10px;
  background: white;
  max-width: 22rem;
  color: rgba(0,0,0,0.5);
  h4 {
    border-bottom: 1px solid rgba(0,0,0,0.15);
    padding-bottom: 1rem;
  }
  p {
    font-size: 14px;
  }
  .link {
    color: ${getColor('main')};
    font-weight: 600;
  }
  ${Button} {
    width: 100%;
  }
`
